import { ChannelType } from "./conversations"

export const mapToFalkonAiFile = (x) => {

    return {
        Name: x.file_name,
        Type: ".pdf",
        Status: x.status,
    }
}

export const mapToFalkonUrl = (x) => {

    return {
        Name: x.url,
        Type: x.is_single_url ? "single" : "multiple",
        Status: x.status,
        Base_Url: x.base_url
    }
}

export enum AiAgentStatus {
    ACTIVE = "active",
    INACTIVE = "inactive"
}

export interface AiAgentModel {
    ID: string,
    Name: string,
    Description: string,
    Character_Count: number,
    outOfContextAnswer: string,
    Status: AiAgentStatus,
    Assigned_Channels?: { ID: string, Name: string, Type: ChannelType }[]
}

export const mapToAiAgentModel = (x) => {
    return {
        ID: x.id,
        Name: x.name,
        Description: x.description,
        Character_Count: x.configuration.character_count,
        outOfContextAnswer: x.configuration.fallback_message,
        Status: x.status
    }
}

export const mapToAIAgentAssignedChannel = (x) =>{
    return {
        ID:x.unit_id,
        Name:x.unit_name,
        Type:x.unit_type
    }
}